import { useFlags, useFlagsLoaded } from "@/hooks/useFeatureFlags";
import { useRosterAccessibleSectionsValue } from "../RosterAccessibleSectionsProvider";

export function useShowRosterDashboardTab(): boolean {
  const flags = useFlags();
  const flagsLoaded = useFlagsLoaded();
  const rosterFlagEnabled = flagsLoaded && flags["backoffice-section-roster-activity"] === true;
  const { canViewRosterActivity, loading } = useRosterAccessibleSectionsValue();

  if (!rosterFlagEnabled || loading) {
    return false;
  }

  return canViewRosterActivity;
}
